export function EmpowerStatement() {
  return (
    <section id="empower_statement" className="bg-[#f9f9fc] py-8 md:py-12">
      <div className="container px-3 md:px-6">
        <div className="mb-0 md:mb-6">
          <h2 className="mx-auto max-w-3xl text-center text-[1.6rem] leading-8 font-bold md:text-3xl m-0">
            We put your <span className="text-[#59266D]">interest</span> over
            Banks <span className="text-[#3A868B] italic">interest</span>.
          </h2>

          {/* Subheading to establish relationship with feature cards */}
          <p className="mt-2 md:mt-3 mx-auto max-w-2xl text-center text-md text-gray-600 md:text-lg tracking-wide m-0">
            Here's how you stay in control:
          </p>
        </div>
      </div>
    </section>
  );
}
